import { inject, Injectable } from '@angular/core';
import { ApiService } from './api-service';

@Injectable({
  providedIn: 'root',
})
export class TagsService {
  private apiService = inject(ApiService);

  async getSiteTags(siteId: string): Promise<string[]> {
    return this.apiService.get<string[]>(`api/tag/site/${siteId}`);
  }
}
